import React from 'react'

function Box({ children, ...rest }) {
    return (
        <div className={`rounded-[20px] p-5 ${rest.className}`} style={{ boxShadow: '0px 2px 24px 0px #0000001F' }}>
            {children}
        </div>
    )
}

export default Box